// extracted by mini-css-extract-plugin
export var logo = "logo-module--logo--1Z4az";
export var gry = "logo-module--gry--FsdhR";